import moment from 'moment-timezone';

export const formatDate = (submissionDate: string): string => {
  const formattedDate = moment(submissionDate).tz('Europe/London').format('DD MMM YYYY, HH:mm');
  return formattedDate;
};
